import styled from 'styled-components';

export const SelectedStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  /* width: 250px; */
  font-size: 15px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  line-height: 32px;
  /* overflow: hidden; */
  /* width: 100%; */
`;

export const SelectOption = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex: none;
  justify-content: space-between;
  align-items: center;
  gap: 4px 12px;
  font-size: 15px;
  line-height: 18px;
  cursor: pointer;
  padding: 4px;
  padding-right: 20px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.gray};

  ${({ selected, theme }) => selected && `background-color: ${theme.gray};`}

  :hover {
    background-color: ${({ theme }) => theme.gray};
  }
`;

// Multi-select tag styled component
export const SelectedTag = styled.div`
  background-color: ${({ theme }) => theme.primary};
  /* border: 1px solid ${({ theme }) => theme.lightGray}; */
  border-radius: 16px;
  padding: 2px 8px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 4px;
  max-width: 120px;

  > p {
    color: ${({ theme }) => theme.white} !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const AdminSelectWrapperStyled = styled.div<{
  $opened?: boolean;
  $shadowDesign?: boolean;
}>`
  position: relative;
  border-radius: 200px;
  display: flex;
  align-items: center;
  padding: 0 24px;

  cursor: pointer;
  font-size: ${({ theme }) => theme.input.fontSize};
  line-height: 18px;
  color: ${({ theme }) => theme.darkGray};
  /* padding: 0 8px; */
  height: ${({ theme }) => theme.input.height};
  background-color: ${({ theme, $shadowDesign }) =>
    $shadowDesign ? theme.white : 'none'};
  border: 1px solid
    ${({ theme, $shadowDesign }) =>
      $shadowDesign ? '#e3e3e3' : `${theme.darkGray}80`};
  box-shadow: ${({ theme, $shadowDesign }) =>
    $shadowDesign ? theme.shadows.shadow1 : 'none'};

  ${({ $opened, theme }) => $opened && `border: 1px solid ${theme.primary};`}

  @media (max-width: 800px) {
    width: 100%;
    flex: none;
  }
`;

export const AdminSelectWrapperChildStyled = styled.div`
  /* padding: 0 0 0 20px; */
  border-radius: 200px 0 0 200px;
  height: ${({ theme }) => theme.input.height};
  display: flex;
  width: 100%;

  @media (max-width: 800px) {
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
    width: 100%;
  }
`;

export const ChevronStyled = styled.div`
  position: absolute;
  right: 16px;
  /* left: auto; */
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1;
  height: 16px;
  pointer-events: none;
`;

export const ProviderImage = styled.div<{
  image?: string | null;
}>`
  ${({ image }) => !image && 'display: none;'}
  flex: none;
  width: 28px;
  height: 28px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
